import yingyunCenter from './yingyunCenter'
import financialCenter from './financialCenter'
import threeGuaranteesManagement from './threeGuaranteesManagement'
import qualityControManagement from './qualityControManagement'
import customerManage from './customerManage/index.js'
import sanbaoCenter from './sanbaoCenter/index.js'
import delimitCompany from './delimitCompany/index.js'
import transportCapacityResources from './transportCapacityResources/index.js'
import transportResources from './transportResources/index.js'
import priceSystem from './priceSystem/index.js'
import huidanCenter from './huidanCenter/index.js'
import paraSettings from './paraSettings/index.js'
import warehouseManagement from './warehouseManagement/index.js' // 仓储管理
import moreService from './moreService/index.js' // 更多服务



const All_Config = {
  ...yingyunCenter,
  ...financialCenter,
  ...threeGuaranteesManagement,
  ...qualityControManagement,
  ...customerManage,
  ...sanbaoCenter,
  ...delimitCompany,
  ...transportCapacityResources,
  ...transportResources,
  ...priceSystem,
  ...huidanCenter,
  ...paraSettings,
  ...warehouseManagement,
  ...moreService,
}

// 如果配置项有返回则取配置项中的值，否则取本地配置
export function getCustomizedConfigByKey(keys, otherOpt) {
  // 处理入参
  if (!keys) {
    return false
  }
  otherOpt = otherOpt || {}
  // getCustomizedConfigByKey默认判断的是当前登录企业的tmscode，但是有时候业务需要判断该企业的上下游业务tmscode，这时候需要外部自己传入tmsCode
  const customComparedCode = otherOpt.tmsCode || null
  // 是否走缓存
  const useCache = otherOpt.cache || false
  if (useCache && typeof keys == 'string' && typeof getCustomizedConfigByKey[keys] == 'boolean') {
    return getCustomizedConfigByKey[keys]
  }
  if (typeof keys == 'string') {
    keys = [keys]
  }

  if (!Array.isArray(keys)) {
    console.error('入参请传入数组，不要传入object对象')
    return {}
  }
  try {
    const u = window.LQAPI.getUserInfo()
    let tmscode = u.TMSCode
    if (customComparedCode) {
      tmscode = customComparedCode
    }
    const obj = {}
    keys.forEach(key => {
      if (All_Config[key]) {
        const codeList = All_Config[key]
        obj[key] = codeList.includes(tmscode)
      } else {
        obj[key] = false
      }
    })
    if (useCache && keys.length == 1) {
      getCustomizedConfigByKey[keys[0]] = !!obj[keys[0]]
      return obj[keys[0]]
    }
    return keys.length == 1 ? obj[keys[0]] : obj
  } catch (error) {
    console.log(error)
    return false
  }
}
